// From Tailwind's `xl` breakpoint up the open cart drawer slides in over the right edge of the menu
// without a scrim, and the menu keeps its width. This has to match the drawer's `xl:` classes.
export const CART_DRAWER_DOCKED_QUERY = '(min-width: 1280px)'

export function isCartDrawerDocked() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(CART_DRAWER_DOCKED_QUERY).matches
}
